import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";

export interface RegistrationNumbers {
  /** TODO: Fill with attributes */
  placeholder: string;
}
export default class RegistrationNumberService {
  private httpClient = makeHttpClient();

  export(ids: number[], customerId: number, switchCustomer: any) {
    const params = new URLSearchParams();
    if (ids.length == 0) {
      throw new Error("!!! NOTHING TO EXPORT !!!");
    } else {
      ids.map(id => {
        params.append("registration_id", "" + id);
      });
      params.append("switch_customer", "" + switchCustomer);
      const url = `${
        env.customerUrl
      }export/registrations/?customer_id=${customerId}&${params.toString()}`;
      this.httpClient.get(url, { responseType: "blob" }).then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "RegistrationNumbers.xlsx"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    }
  }
  upload(file: File, customer_id: any) {
    /*
                Initialize the form data
            */
    const formData = new FormData();

    /*
               Add the form data we need to submit
           */
    formData.append("registrations", file);

    /*
         Make the request to the POST /single-file URL
       */
    let url = `${env.customerUrl}import/registrations/`;
    if (customer_id != null) {
      url = `${url}?customer_id=${customer_id}`;
    }
    return this.httpClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  getAll(customer_id: number, reg_num_id: any) {
    if (reg_num_id) {
      return _unwrapAxiosResponse(
        this.httpClient.get<RegistrationNumbers>(
          env.customerUrl +
            "registrations/" +
            reg_num_id +
            "/?id=" +
            customer_id
        )
      );
    }
    return _unwrapAxiosResponse(
      this.httpClient.get<RegistrationNumbers>(
        env.customerUrl + "registrations/" + "?id=" + customer_id
      )
    );
  }

  create(form: any) {
    const data = {
      customer: form.customer,
      country: form.country,
      stream: form.stream,
      scheme: form.scheme,
      additional_info: form.additional_info,
      registration_no: form.registration_no,
      membership_no_with_scheme: form.membership_no_with_scheme
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<RegistrationNumbers>(
        env.customerUrl + "registrations/",
        data
      )
    );
  }

  update(form: any) {
    const data = {
      id: form.id,
      customer: form.customer,
      country: form.country,
      stream: form.stream,
      scheme: form.scheme,
      registration_no: form.registration_no,
      additional_info: form.additional_info,
      membership_no_with_scheme: form.membership_no_with_scheme
    };
    return _unwrapAxiosResponse(
      this.httpClient.put<RegistrationNumbers>(
        env.customerUrl + "registrations/" + form.customer + "/",
        data
      )
    );
  }

  delete(reg_num_id: any) {
    const url = env.customerUrl + "registrations/" + reg_num_id + "/";
    return _unwrapAxiosResponse(
      this.httpClient.delete<RegistrationNumbers>(url)
    );
  }
}
